<template>
  <div class="pageBody">
    <phoneHero/>
    <!--Our Story and Stay in the Know (separated for styles)-->
    <storySignup/>
    <div class="testimony">
      <a id="Media"></a>
      <div class="media">
        <h1>Our Media</h1>
        <h2>Check back here often to hear what our users are saying about our apps, and to see where I have been seen promoting our mission and brand.</h2>
        <div class="logos">
          <img src="./assets/ABC7Logo.png"/>
          <img src="./assets/AutismSpeaksLogo.jpeg"/>
          <img src="./assets/bloomberglogo.png"/>
          <img src="./assets/vidlogo_Cheddar.jpg"/>
          <img src="./assets/ForbesLogo.png"/>
          <img src="./assets/fox-5-logo.png"/>
          <img src="./assets/GoLiveGirl.jpg"/>
          <img src="./assets/vidlogo_iFund.jpg"/>
          <img src="./assets/Lifetime_logo_2020.svg"/>
          <img src="./assets/NewsDayLogo.png"/>
          <img src="./assets/News12Logo.gif"/>
          <img src="./assets/PatchLogo.png"/>
          <img src="./assets/entremaglogo.jpg"/>
          <img src="./assets/NowThis.png"/>
          <img src="./assets/todaylogo.png"/>
        </div>
        <videoSlider/>
      </div>
        <div class="quote">
          <h1>My son Byron has a hard time making friends. We showed him the MAF app beta and he just lit up. He loves the app a little too much. :)</h1>
          <h2>Steve W. , Lancaster PA</h2>
        </div>
    </div>
    <div class="bottom">
      <a id="TheApp"></a>
      <h1>The App</h1>
      <imageSlider/>
      <h2>Have questions about the app? <a href="./MAF-FAQs.pdf" target="_blank">Visit our FAQs.</a></h2>
    </div>
  </div>
</template>

<script>
import phoneHero from "./sections/PhoneHero";
import storySignup from "./sections/StorySignup";
import imageSlider from "./sliders/ImageSlider";
import videoSlider from "./sliders/videoSlider";

export default {
  name: "pageBody",
  components: {
    phoneHero,
    storySignup,
    imageSlider,
    videoSlider,
  }
}
</script>

<style scoped>

.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  width: 75%;
}

@media screen and (min-width: 767px) {
  .logos {
    margin-bottom: 5rem;
  }
}

.logos img {
  max-width: 150px;
  margin: 1rem;
}

.pageBody {
  display: flex;
  flex-flow: column;
  width:100%;
  text-align:center;
  align-items: center;
}

h2 a {
  color: black !important;
}

/* TESTIMONY */

.testimony{
  width:100%;
  margin-top: 3rem;
}

.media, .quote {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media {
  margin-bottom: 10rem;
}

.media h1 {
  color:#F06377;
  font-size: 60px;
  font-family: 'chunk';
  font-weight: inherit;
}
.media h2 {
  width: 60%;
  font-size: 25px;
  margin-bottom: 5rem;
}

.quote {
  background-image: url("./assets/bg_quote.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 2rem 1rem;
}
.quote h1 {
  color:white;
  font-size: 50px;
  padding-top: 2rem;
  width: 80%;
  font-family: 'chunk';
  font-weight: inherit;
}
.quote h2 {
  color:#232323;
  font-size: 35px;
  width: 60%;
  font-weight: bold;
}
@media screen and (max-width:767px){
  .media h1 {
    font-size: 30px;
    width: 80%;
  }
  .media h2 {
    font-size: 18px;
    width:80%;
  }
  .quote h1 {
    font-size: 4vw;
    padding-top:3vw;
    padding-left:3vw;
    width:90%;
  }
  .quote h2 {
    font-size: 3vw;
    width:60%;
    font-weight:bold;
  }
}

/* BOTTOM */

.bottom {
  padding: 3rem 0;
  width: 100%;
}

h1 {
  color:#F06377;
  font-size: 60px;
  font-family: 'chunk';
  font-weight: inherit;
}
@media screen and (max-width:1023px) {
  h1 {
    font-size: 3.5vmax;
  }
  .leftArrow {
    margin: 20px;
    height: 20vw;
  }
  .slide {
    width: 60%;
    margin: 0;
  }
  .rightArrow {
    margin: 20px;
    height: 20vw;
  }
}

</style>